import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { SessionWithId } from '../Models/session';
import { theme } from '../Mui/Theme';

interface DifficultyChipProps {
    session: SessionWithId;
}

export const Chips: React.FC<DifficultyChipProps> = ({ session }) => {
    return (
        <Stack
            direction="row"
            spacing={1}
            sx={{
                display: 'flex',
                justifyContent: 'center',
            }}
        >
            {session.session.difficulty !== '' && (
                <Chip
                    label={session.session.difficulty}
                    size="small"
                    sx={{
                        backgroundColor: theme.palette.info.dark,
                        color: theme.palette.info.contrastText,
                        fontWeight: 'bold',
                    }}
                />
            )}

            {session.session.online && (
                <Chip
                    label="Online"
                    size="small"
                    sx={{
                        backgroundColor: theme.palette.success.dark,
                        color: theme.palette.success.contrastText,
                        fontWeight: 'bold',
                    }}
                />
            )}
        </Stack>
    );
};
